import React, {useContext, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import {
    getAuthHeader, getLocalStorageItem,
    objectLang,
    refreshMoney,
    setErrorWindow,
    setGlobalMoneyObject,
    setLocalStorageItem
} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import config from "../config.json"
import {ModalCreateCardBankClass} from "../elements/ModalCreateCardBankClass"
import {useNavigate} from "react-router-dom"

export const AddCardBankPage = () => {
    setLocalStorageItem('page', 'AddCardBankPage')
    const lang = objectLang().language
    const l = lang.lang
    const auth = useContext(AuthContext)
    const navigate = useNavigate()
    const {loading, request} = useHttp()
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [show, setShow] = useState(true)
    const [isNew, setIsNew] = useState(false)
    const [view, setView] = useState(true)

    const isNewMoney = getLocalStorageItem('isNewMoney')
    if (isNewMoney) {
        setIsNew(Boolean(isNewMoney))
        localStorage.removeItem('isNewMoney')
    }

    const data = {
        title: lang.body.cardBankPage.titleAdd,
        desc: lang.body.cardBankPage.descAdd,
        btnOKColor: 'success',
        btnCancelColor: 'secondary',
        btnOK: lang.body.cardBankPage.btnCreate,
        btnCancel: lang.body.cardBankPage.btnCancel
    }

    const closeHandler = () => {
        setShow(false)
    }

    const addCardHandler = async (bodyObject) => {
        if (!bodyObject['name'] || !bodyObject['type'] || !bodyObject['currency'] || !bodyObject['date']) {
            setAllowed(false)
            setDataModal(setErrorWindow(
                '',
                591,
                '',
                '',
                `replaceTo /${l}/money/add-card`
            ))
            return
        }
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/money/settings/add-card`,
                'POST',
                bodyObject,
                {
                    Authorization: getAuthHeader(auth)
                })
            if (data.status > 201) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                setTimeout(() => {
                    setView(true)
                }, 1000)
                setGlobalMoneyObject(await refreshMoney(auth, request).then())
                navigate(`/${l}/money/settings`)
            }

        } catch (e) {
            navigate(`/${l}/money/main`)
        }
    }

    const cancelHandler = async () => {
        navigate(`/${l}/money/settings`)
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return (
            <ModalWin data={dataModal}/>
        )
    }

    if (view) {
        return (
            <>
                {/*<MoneySettingsPage/>*/}
                <ModalCreateCardBankClass
                    lang={lang}
                    show={show}
                    data={data}
                    addCardHandler={addCardHandler}
                    cancelHandler={cancelHandler}
                    closeHandler={closeHandler}
                    isNew={isNew}
                />
            </>
        )
    } else {
        return <LoaderClass/>
    }
}